import style from './MiaPayButton.module.css';
import { EVENT_NAMES, useSendEventLog } from '../../../event-log';
import { useStartMiaPaySession } from '../../hooks/useStartMiaPaySession';
import { RedirectPaymentResult } from '../../payment.types';

interface MiaPayButtonProps {
    orderId: string;
    onPaymentSuccess: (result: RedirectPaymentResult) => void;
    onPaymentFailed: () => void;
    onError: (error: unknown) => void;
}

const MiaPayButton = ({
    orderId,
    onPaymentSuccess,
    onPaymentFailed,
    onError,
}: MiaPayButtonProps) => {
    const miaPaySession = useStartMiaPaySession();
    const { sendEvent } = useSendEventLog();

    function onRequestMiaPayment() {
        sendEvent({ name: EVENT_NAMES.paymentInitiated.MiaPay });
        miaPaySession.mutate(
            { orderId },
            {
                onSuccess: (data) => onPaymentSuccess(data),
                onError: () => onPaymentFailed(),
            },
        );
    }

    return (
        <button
            className={`${style.pay_button} miapay-checkout-pay ${style.miapayCheckoutPay}`}
            id="miaCheckoutButton"
            onClick={onRequestMiaPayment}
        >
            <div className={style.miapayCheckoutButtonLogo}>
                <img
                    alt="MiaPay"
                    height="24"
                    src="/images/mia-logo-rounded.svg"
                />
            </div>
        </button>
    );
};

export { MiaPayButton };
